import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import { MainLayout } from "../layouts/MainLayout";
import { yodaAgentActions } from "../logic/actions";
import { AgentsFilter } from "../components/agent";
import Agent from "../components/agent/Agent";
import config from "../utils/globalConfig";
import { LoadingFrame } from "../components/common/LoadingFrame";
import { getLocalizedString } from "../utils";
import useVirtualList from "../hooks/useVirtualList";
import { PreLoader } from "../components/loader/PreLoader";
import { resetScroll } from "../utils/resetScroll";
import useResponsive from "../hooks/useResponsive";
import MobileScrollCTA from "../components/MobileScrollCTA";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const AgentsPage = () => {
  const dispatch = useDispatch();

  const { agents } = useSelector((state) => state.yodaAgent);
  const { offsetTop } = useSelector((state) => state.system);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const { scrolledToBottom } = useSelector((state) => state.layout);

  const [filteredAgents, setFilteredAgents] = useState(undefined);

  const { getVirtualItems, reset } = useVirtualList({ enableAutoScroll: true });

  const { isMobile, isTabletSm } = useResponsive();

  const displayedAgents = useMemo(
    () => getVirtualItems(filteredAgents),
    [getVirtualItems, filteredAgents],
  );

  useEffect(() => {
    dispatch(yodaAgentActions.getAll());
  }, []);

  useEffect(() => {
    setFilteredAgents(agents);
  }, [agents]);

  const filterAgents = (query, status) => {
    reset();
    resetScroll();
    const selectedAgents = agents.filter(
      (agent) =>
        (query !== ""
          ? agent.name.toLowerCase().includes(query) ||
            agent.firstName.toLowerCase().includes(query)
          : true) &&
        (status !== "all"
          ? agent.status.toLowerCase() === status.toLowerCase()
          : true),
    );

    setFilteredAgents(selectedAgents);
  };

  if (
    me?.error === "not-authorized" ||
    (me?.role && me?.role !== "CustomerCare")
  ) {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: me?.error === "not-authorized",
            roleError: me?.role && me?.role !== "CustomerCare",
          },
        }}
      />
    );
  }
  return (
    <MainLayout client>
      <LoadingFrame agents={true}></LoadingFrame>
      <Flex width={1} flexDirection="column" position={["unset", "relative"]}>
        <Box
          sx={{
            position: "sticky",
            top: [offsetTop, 0],
            zIndex: 1,
            background: "white",
            width: "100%",
            maxWidth: config.VIEWPORT,
            padding: ["10px 0 0", "10px 0 0", "30px 0 16px"],
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <AgentsFilter filterAgents={filterAgents} />
        </Box>
        <Flex width={1} flexDirection="column" pt={4} p={[3, null, 0]}>
          <Box
            sx={{
              width: "100%",
              marginTop: [0, null],
            }}
          >
            {!!displayedAgents?.length &&
              displayedAgents.map((agent, index) => (
                <Agent {...agent} key={index.toString()} />
              ))}
            {!!displayedAgents?.length &&
              displayedAgents?.length < filteredAgents?.length &&
              scrolledToBottom && (
                <Flex
                  justifyContent={"center"}
                  alignContent={"center"}
                  sx={{ width: "100%", py: "20px" }}
                >
                  <PreLoader color="black" size="sm" />
                </Flex>
              )}
            {displayedAgents !== undefined && displayedAgents.length == 0 && (
              <Flex
                style={{
                  height: "30px",
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                justifyContent={"center"}
                mb={4}
                fontSize={12}
              >
                {getLocalizedString("AGENTS IS EMPTY")}
              </Flex>
            )}
            {(isMobile || isTabletSm) &&
              !!displayedAgents?.length &&
              displayedAgents?.length < filteredAgents?.length && (
                <MobileScrollCTA />
              )}
          </Box>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export { AgentsPage };
